import SelectTable from "./formComponents/SelectTable";

interface FilterItem {
    label: string;
    name: string;
    table: string;
}

interface GenericFiltersProps {
    filters: FilterItem[];
    onFilterChange: (name: string, value: any) => void;
    values: Record<string, any>;
}

const GenericFilters: React.FC<GenericFiltersProps> = ({
    filters,
    onFilterChange,
    values,
}) => {
    return (
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-4 m-1">
            {filters.map((filter) => (
                <SelectTable
                    key={filter.name}
                    table={filter.table}
                    placeholder={`Select ${filter.label}`}
                    onChange={(value:any) => onFilterChange(filter.name, value)}
                    value={values[filter.name]}
                />
            ))}
        </div>
    );
};

export default GenericFilters;
